module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_sentrert logo_neg(hvit).2425de04.svg";